import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { componentConstants } from '@components/tuain.module.config';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';

const ERROR_TYPES = {
  DEFAULT: 'warning',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  DANGER: 'error',
};

@Component({
  standalone: true,
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents],
  selector: 'app-form-error',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-form-error.component.html',
})
export class AppFormErrorComponent implements OnInit {
  errorStyle: any = {
    // background: '#ffffff',
    'border-radius': '0px',
    'margin-bottom': '0px',
    border: '0px',
    padding: '0px',
  };
  componentConstants: any;
  @Input() errorTitle: any;
  @Input() errorMessage: any;
  @Input() errorType: any;
  type: any;
  showDetail: boolean;
  constructor() {
    this.componentConstants = componentConstants;
    this.showDetail = false;
  }

  ngOnInit(): void {
    this.type = ERROR_TYPES[this.errorType] ?? ERROR_TYPES.DEFAULT;
  }

  toggleDetail() {
    this.showDetail = !this.showDetail;
  }
}
